import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ToggleField from '../../../FormLegacy/FormFieldsV2/ToggleField'

import TimeSelectInput from './TimeSelectInput'

const getTimeOptions = (t) => [
  {
    value: '1 hour',
    label: t('create-event:setupAutomatedReminders.hoursBeforeEvent', { count: 1 }),
  },
  {
    value: '3 hours',
    label: t('create-event:setupAutomatedReminders.hoursBeforeEvent', { count: 3 }),
  },
  {
    value: '6 hours',
    label: t('create-event:setupAutomatedReminders.hoursBeforeEvent', { count: 6 }),
  },
  {
    value: '12 hours',
    label: t('create-event:setupAutomatedReminders.hoursBeforeEvent', { count: 12 }),
  },
  {
    value: '1 days',
    label: t('create-event:setupAutomatedReminders.daysBeforeEvent', { count: 1 }),
  },
  {
    value: '2 days',
    label: t('create-event:setupAutomatedReminders.daysBeforeEvent', { count: 2 }),
  },
  {
    value: '3 days',
    label: t('create-event:setupAutomatedReminders.daysBeforeEvent', { count: 3 }),
  },
  {
    value: '4 days',
    label: t('create-event:setupAutomatedReminders.daysBeforeEvent', { count: 4 }),
  },
  {
    value: '5 days',
    label: t('create-event:setupAutomatedReminders.daysBeforeEvent', { count: 5 }),
  },
  {
    value: '6 days',
    label: t('create-event:setupAutomatedReminders.daysBeforeEvent', { count: 6 }),
  },
  {
    value: '7 days',
    label: t('create-event:setupAutomatedReminders.daysBeforeEvent', { count: 7 }),
  },
]

const SetupAutomatedReminders = ({
  formState,
  handleCheckboxChange,
  handleFieldChange,
  eventType,
}) => {
  const { t } = useTranslation(['create-event'])
  const timeOptions = getTimeOptions(t)
  return (
    <div className="extra-field">
      {eventType !== 'reminder' ? (
        <React.Fragment>
          <div className="input-row">
            <div className="input-container inline">
              <ToggleField name="rsvpd" onChange={handleCheckboxChange} value={formState.rsvpd} />
              <div className="input-label">
                {t('create-event:setupAutomatedReminders.remindAttendeesWhoRsvpd')}
              </div>
            </div>
          </div>
          {formState.rsvpd && (
            <TimeSelectInput
              summary={t('create-event:setupAutomatedReminders.attendeesSummary', {
                time: formState.rsvpdTime || '',
              })}
              value={formState.rsvpdTime}
              handleFieldChange={handleFieldChange}
              startTime={formState.timeStart}
              name="rsvpdTime"
              options={timeOptions}
            />
          )}
        </React.Fragment>
      ) : null}

      <div className="input-row">
        <div className="input-container inline">
          <ToggleField name="nonRsvpd" onChange={handleCheckboxChange} value={formState.nonRsvpd} />
          <div className="input-label">
            {t('create-event:setupAutomatedReminders.remindEveryone')}
          </div>
        </div>
      </div>
      {formState.nonRsvpd && (
        <TimeSelectInput
          summary={t('create-event:setupAutomatedReminders.allResidentsSummary', {
            time: formState.nonRsvpdTime || '',
          })}
          value={formState.nonRsvpdTime}
          handleFieldChange={handleFieldChange}
          startTime={formState.timeStart}
          name="nonRsvpdTime"
          options={timeOptions}
        />
      )}
    </div>
  )
}

SetupAutomatedReminders.propTypes = {
  formState: PropTypes.object,
  handleCheckboxChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  eventType: PropTypes.string,
}

export default SetupAutomatedReminders
